import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  shape1Major: {
    width: 62,
    overflow: "hidden",
    top: 249.5,
    left: 271.5,
    position: "absolute",
    zIndex: 3,
    height: 69,
    // clipPath: "polygon(50% 100%, 50% 100%, 100% 0, 0 0)",
    // shapeOutside: "polygon(50% 100%, 50% 100%, 100% 0, 0 0)",

    [emulatorScreen(theme)]: {
      width: 266,
      top: 26.5,
      left: 70,
      height: 57,
    },
    [mobileScreen(theme)]: {
      width: 39,
      top: 93.5,
      left: 180.5,
      height: 35.5,
    },
  },

  shape2Major: {
    width: 62,
    overflow: "hidden",
    top: 323,
    left: 271.5,
    position: "absolute",
    zIndex: 3,
    height: 68.5,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 100,
      top: 31,
      left: 75,
      height: 53,
    },
    [mobileScreen(theme)]: {
      width: 39,
      top: 131.5,
      left: 180.5,
      height: 35.5,
    },
  },


  shape3Major: {
    width: 65,
    overflow: "hidden",
    top: 327,
    left: 271.5,
    position: "absolute",
    zIndex: 3,
    height: 143,
    // clipPath: "polygon(100% 0, 0% 100%, 100% 100%)",
    // shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 65,
      top: 32,
      left: 266,
      // height: 51.5,
    },
    [mobileScreen(theme)]: {
      top: 133,
      left: 181.5,
      width: 40,
      height: 72.5,
    },
  },

  shape4Major: {
    width: 63,
    overflow: "hidden",
    top: 405,
    left: 271.5,
    position: "absolute",
    zIndex: 3,
    height: 69,
    [emulatorScreen(theme)]: {
      width: 67.5,
      top: 81.5,
      left: 75,
      height: 45.5,
    },
    [mobileScreen(theme)]: {
      width: 38,
      top: 172,
      left: 180.5,
      height: 34,
    },
  },

  shape5Major: {
    width: 73.5,
    overflow: "hidden",
    top: 241,
    left: 342,
    position: "absolute",
    zIndex: 3,
    height: 160,
    clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
    shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
    [emulatorScreen(theme)]: {
      width: 54,
      top: 82.5,
      left: 144.5,
      height: 44.5,
    },
    [mobileScreen(theme)]: {
     width: 60,
      top: 78,
      left: 225,
      height: 105,
    },
  },

  shape6Major: {
    width: 239,
    overflow: "hidden",
    bottom: 190,
    left: 24,
    position: "absolute",
    zIndex: 3,
    height: 74,
    [emulatorScreen(theme)]: {
      clipPath: "polygon(0 4%, 50% 100%, 100% 4%)",
      width: 114,
      top: 81.5,
      left: 146,
      height: 44,
    },
    [mobileScreen(theme)]: {
      top: 170.1,
      left: 28,
      width: 148,
      height: 36,
    },
  },
});
export default styles;
